import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import { store } from 'client/store';

export type WtrState = ReturnType<typeof store.getState>;
export type WtrDispatch = typeof store.dispatch;

export const useWtrDispatch: () => WtrDispatch = useDispatch;
export const useWtrSelector: TypedUseSelectorHook<WtrState> = useSelector;
